import { ELEM_BYTES_LEN } from './data';
export const PROOF_FLAG_LEN = 2;
export const NOT_EMPTIES_LEN = ELEM_BYTES_LEN - PROOF_FLAG_LEN;
//# sourceMappingURL=proof.js.map